var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModuleServiceGoalImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 49,
    r: 49,
    fill: "#F9F9F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_152_535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.6011 48.9991H41.3971C40.0631 49.0067 38.8224 48.3159 38.1264 47.1779C37.4376 46.0671 37.3805 44.6768 37.9757 43.5133L45.6034 30.6249C46.2747 29.3596 47.5938 28.5723 49.0262 28.5821C50.4585 28.5919 51.7667 29.3971 52.4207 30.6715L59.9971 43.4666C60.6141 44.6389 60.5665 46.0498 59.872 47.1779C59.1759 48.3159 57.9351 49.0068 56.6011 48.9991ZM48.9991 30.2157C48.1689 30.2031 47.405 30.6676 47.034 31.4104L39.4064 44.2988C39.0871 44.9468 39.1295 45.7144 39.518 46.3233C39.9184 46.9761 40.6313 47.3715 41.3971 47.3657H56.6011C57.3668 47.3715 58.0797 46.976 58.4801 46.3233C58.8748 45.6973 58.9075 44.9088 58.5662 44.2522L50.9897 31.4571C50.6232 30.6921 49.8473 30.2082 48.9991 30.2157Z",
    fill: "url(#paint0_linear_152_535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0042 42.4638C48.5531 42.4638 48.1875 42.0982 48.1875 41.6471V34.2971C48.1875 33.8461 48.5531 33.4805 49.0042 33.4805C49.4552 33.4805 49.8208 33.8461 49.8208 34.2971V41.6471C49.8208 42.0982 49.4552 42.4638 49.0042 42.4638Z",
    fill: "url(#paint1_linear_152_535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0042 45.7349C49.4552 45.7349 49.8208 45.3693 49.8208 44.9182C49.8208 44.4672 49.4552 44.1016 49.0042 44.1016C48.5531 44.1016 48.1875 44.4672 48.1875 44.9182C48.1875 45.3693 48.5531 45.7349 49.0042 45.7349Z",
    fill: "url(#paint2_linear_152_535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7792 67.4077C67.3281 67.4077 66.9625 67.042 66.9625 66.591V62.8833H51.4458V66.591C51.4458 67.042 51.0802 67.4077 50.6292 67.4077C50.1781 67.4077 49.8125 67.042 49.8125 66.591V62.0667C49.8125 61.6156 50.1781 61.25 50.6292 61.25H67.7792C68.2302 61.25 68.5958 61.6156 68.5958 62.0667V66.591C68.5958 67.042 68.2302 67.4077 67.7792 67.4077Z",
    fill: "url(#paint3_linear_152_535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9534 67.4061C26.5024 67.4061 26.1367 67.0405 26.1367 66.5894V61.2484C26.1386 59.4451 27.6 57.9837 29.4034 57.9818H46.5534V54.7151C46.5534 54.2641 46.919 53.8984 47.3701 53.8984C47.8211 53.8984 48.1867 54.2641 48.1867 54.7151V58.7984C48.1867 59.2495 47.8211 59.6151 47.3701 59.6151H29.4034C28.5017 59.6161 27.7711 60.3468 27.7701 61.2484V66.5894C27.7701 67.0405 27.4044 67.4061 26.9534 67.4061Z",
    fill: "url(#paint4_linear_152_535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0458 67.4061C70.5948 67.4061 70.2292 67.0405 70.2292 66.5894V61.2484C70.2281 60.3468 69.4975 59.6161 68.5958 59.6151H50.6292C50.1781 59.6151 49.8125 59.2495 49.8125 58.7984V54.7151C49.8125 54.2641 50.1781 53.8984 50.6292 53.8984C51.0802 53.8984 51.4458 54.2641 51.4458 54.7151V57.9818H68.5958C70.3992 57.9837 71.8606 59.4451 71.8625 61.2484V66.5894C71.8625 67.0405 71.4969 67.4061 71.0458 67.4061Z",
    fill: "url(#paint5_linear_152_535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3651 67.4077C46.9141 67.4077 46.5484 67.042 46.5484 66.591V62.8833H31.0318V66.591C31.0318 67.042 30.6661 67.4077 30.2151 67.4077C29.7641 67.4077 29.3984 67.042 29.3984 66.591V62.0667C29.3984 61.6156 29.7641 61.25 30.2151 61.25H47.3651C47.8161 61.25 48.1818 61.6156 48.1818 62.0667V66.591C48.1818 67.042 47.8161 67.4077 47.3651 67.4077Z",
    fill: "url(#paint6_linear_152_535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9651 52.2688H31.0318C30.7607 52.2688 30.5073 52.1344 30.3553 51.91C30.2033 51.6855 30.1726 51.4003 30.2733 51.1486L33.54 42.9819C33.6642 42.672 33.9645 42.4688 34.2984 42.4688H39.0596C39.5106 42.4688 39.8763 42.8344 39.8763 43.2854C39.8763 43.7364 39.5106 44.1021 39.0596 44.1021H34.8512L32.2378 50.6354H65.7592L63.1459 44.1021H58.9373C58.4862 44.1021 58.1206 43.7364 58.1206 43.2854C58.1206 42.8344 58.4862 42.4688 58.9373 42.4688H63.6984C64.0324 42.4688 64.3327 42.672 64.4569 42.9819L67.7235 51.1486C67.8243 51.4003 67.7936 51.6855 67.6416 51.91C67.4896 52.1344 67.2362 52.2688 66.9651 52.2688Z",
    fill: "url(#paint7_linear_152_535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1482 55.5328H31.8482C30.9465 55.5318 30.2159 54.8011 30.2148 53.8995V51.4495C30.2148 50.9984 30.5805 50.6328 31.0315 50.6328C31.4825 50.6328 31.8482 50.9984 31.8482 51.4495V53.8995H66.1482V51.4495C66.1482 50.9984 66.5138 50.6328 66.9648 50.6328C67.4159 50.6328 67.7815 50.9984 67.7815 51.4495V53.8995C67.7805 54.8011 67.0498 55.5318 66.1482 55.5328Z",
    fill: "url(#paint8_linear_152_535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.705 44.1H58.9438C58.4927 44.1 58.1271 43.7344 58.1271 43.2833C58.1271 42.8323 58.4927 42.4667 58.9438 42.4667H62.8883V26.1333H35.1216V42.4667H39.0661C39.5171 42.4667 39.8828 42.8323 39.8828 43.2833C39.8828 43.7344 39.5171 44.1 39.0661 44.1H34.3049C33.8539 44.1 33.4883 43.7344 33.4883 43.2833V26.1333C33.4893 25.2317 34.22 24.501 35.1216 24.5H62.8883C63.7899 24.501 64.5206 25.2317 64.5216 26.1333V43.2833C64.5216 43.7344 64.156 44.1 63.705 44.1Z",
    fill: "url(#paint9_linear_152_535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5833 73.4987C26.3282 73.4987 24.5 71.6705 24.5 69.4154C24.5 67.1602 26.3282 65.332 28.5833 65.332C30.8385 65.332 32.6667 67.1602 32.6667 69.4154C32.664 71.6694 30.8374 73.496 28.5833 73.4987ZM28.5833 66.9654C27.2302 66.9654 26.1333 68.0623 26.1333 69.4154C26.1333 70.7685 27.2302 71.8654 28.5833 71.8654C29.9364 71.8654 31.0333 70.7685 31.0333 69.4154C31.0318 68.0629 29.9358 66.9668 28.5833 66.9654Z",
    fill: "url(#paint10_linear_152_535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4193 73.4987C67.1641 73.4987 65.3359 71.6705 65.3359 69.4154C65.3359 67.1602 67.1641 65.332 69.4193 65.332C71.6744 65.332 73.5026 67.1602 73.5026 69.4154C73.4999 71.6694 71.6733 73.496 69.4193 73.4987ZM69.4193 66.9654C68.0662 66.9654 66.9693 68.0623 66.9693 69.4154C66.9693 70.7685 68.0662 71.8654 69.4193 71.8654C70.7724 71.8654 71.8693 70.7685 71.8693 69.4154C71.8678 68.0629 70.7718 66.9668 69.4193 66.9654Z",
    fill: "url(#paint11_linear_152_535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9974 73.4987C46.7422 73.4987 44.9141 71.6705 44.9141 69.4154C44.9141 67.1602 46.7422 65.332 48.9974 65.332C51.2526 65.332 53.0807 67.1602 53.0807 69.4154C53.0781 71.6694 51.2515 73.496 48.9974 73.4987ZM48.9974 66.9654C47.6443 66.9654 46.5474 68.0623 46.5474 69.4154C46.5474 70.7685 47.6443 71.8654 48.9974 71.8654C50.3505 71.8654 51.4474 70.7685 51.4474 69.4154C51.4459 68.0629 50.3499 66.9668 48.9974 66.9654Z",
    fill: "url(#paint12_linear_152_535)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_152_535",
    x1: 37.4216,
    y1: 35.9216,
    x2: 60.6775,
    y2: 36.3804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_152_535",
    x1: 48.1772,
    y1: 36.7098,
    x2: 49.8392,
    y2: 36.7151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_152_535",
    x1: 48.1772,
    y1: 44.6887,
    x2: 49.8388,
    y2: 44.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_152_535",
    x1: 49.6935,
    y1: 63.4636,
    x2: 68.7528,
    y2: 64.4879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_152_535",
    x1: 25.9971,
    y1: 58.7542,
    x2: 48.417,
    y2: 59.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_152_535",
    x1: 49.6728,
    y1: 58.7542,
    x2: 72.0928,
    y2: 59.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_152_535",
    x1: 29.2795,
    y1: 63.4636,
    x2: 48.3387,
    y2: 64.4879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_152_535",
    x1: 29.9769,
    y1: 45.9917,
    x2: 68.0324,
    y2: 48.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_152_535",
    x1: 29.9769,
    y1: 52.3943,
    x2: 67.5204,
    y2: 57.4657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_152_535",
    x1: 33.2917,
    y1: 31.5458,
    x2: 64.8473,
    y2: 32.4261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_152_535",
    x1: 24.4483,
    y1: 68.2678,
    x2: 32.7563,
    y2: 68.4142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_152_535",
    x1: 65.2842,
    y1: 68.2678,
    x2: 73.5922,
    y2: 68.4142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_152_535",
    x1: 44.8623,
    y1: 68.2678,
    x2: 53.1703,
    y2: 68.4142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#351EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F74EF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_152_535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "white",
    transform: "translate(24.5 24.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuleServiceGoalImage);
export default __webpack_public_path__ + "static/media/module_service_goal_image.20834b42a4e055f82251ca8b75d366be.svg";
export { ForwardRef as ReactComponent };